import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { fillDetails } from '../../models/profile';
import numberFormat from '../../utils/numberFormat';

import Gnb from '../../components/Gnb';
import NotFoundPage from '../NotFoundPage';
import RestrictFriend from '../RestrictFriendPage';

export class AddFriendDonePage extends Component {
  constructor(props) {
    super(props);
  }

  handleCloseWindow() {
    if (window.opener) {
      if (window.__BROWSER_NAME__ === "Mobile Safari") {
        const open = window.open(',', '_self');
        if (open) {
          open.close();
        }
      }
    }
    window.close();
  }
  render() {
    const { device, profile } = this.props;
    if (!profile) {
      return (
        <div>
          <Gnb device={device} />
          <NotFoundPage {...this.props} />;
        </div>
      )
    }

    const { name, profileImage, statusMessage, friendCount, spamLevel, isOfficial, isFriend } = profile;
    if (spamLevel === 5) {
      return (<RestrictFriend profile={profile} device={device} />);
    }

    const RenderMultiElement = () => [
      <div id="kakaoHead" className="head_bridge" role="banner" key="header">
        <h1 className="tit_logo">
          <a href="#none" className="link_logo" style={{ padding: 0 }}>
            <span className="ico_plus ico_logo">카카오톡 채널</span>
          </a>
        </h1>
      </div>,
      <div id="kakaoContent" className="cont_bridge" role="main" key="content">
        <h2 id="kakaoBody" className="screen_out">채널 추가영역</h2>
        <div className="inner_bridge inner_bridge2">
          <span className="img_bridge" />
          <strong className="tit_bridge">채널 추가 완료</strong>
          <p className="desc_bridge">
            { name } 채널을<br/>
            카카오톡에 추가하였습니다.
          </p>
          <a href="#none" id="cancel_btn" className="btn_bridge" onClick={this.handleCloseWindow}>확인</a>

          <div className="logout_bridge">
            <a href={`${process.env.REACT_APP_KAKAO_ACCOUNT_URL}/logout?continue=${process.env.REACT_APP_SERVICE_HOST}/logged_out`}
              className="link_logout"
            >
              로그아웃
            </a>
          </div>
        </div>
      </div>
    ];

    return (<RenderMultiElement />);
  }
}

const mapStateToProps = (state, { match: { params: { encodedProfileId } } } ) => {
  const { entities, profile, device, error } = state;
  const profiles = entities.get('profiles', Immutable.Map());
  const selectedProfile = fillDetails(profiles.get(`${encodedProfileId}`), entities);
  return { profile: selectedProfile, device, error };
};

export default connect(
  mapStateToProps, (dispatch) => bindActionCreators({}, dispatch)
)(AddFriendDonePage);



// WEBPACK FOOTER //
// ./src/containers/AddFriendDonePage/index.js